import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getTenantEmployees } from 'app/entities/tenant-employee/tenant-employee.reducer';
import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { getEntities as getPharmacyReturnBills } from 'app/entities/pharmacy-return-bill/pharmacy-return-bill.reducer';
import { getEntities as getAdmissions } from 'app/entities/admission/admission.reducer';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { BillFor } from 'app/shared/model/enumerations/bill-for.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-refund-bill.reducer';

export const PharmacyRefundBillUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const tenantEmployees = useAppSelector(state => state.tenantEmployee.entities);
  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const pharmacyReturnBills = useAppSelector(state => state.pharmacyReturnBill.entities);
  const admissions = useAppSelector(state => state.admission.entities);
  const pharmacyRefundBillEntity = useAppSelector(state => state.pharmacyRefundBill.entity);
  const loading = useAppSelector(state => state.pharmacyRefundBill.loading);
  const updating = useAppSelector(state => state.pharmacyRefundBill.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyRefundBill.updateSuccess);
  const patientTypeValues = Object.keys(PatientType);
  const billForValues = Object.keys(BillFor);

  const handleClose = () => {
    navigate(`/pharmacy-refund-bill${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
    dispatch(getGlucoUsers({}));
    dispatch(getTenantEmployees({}));
    dispatch(getPharmacyBills({}));
    dispatch(getPharmacyReturnBills({}));
    dispatch(getAdmissions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.billDate !== undefined && typeof values.billDate !== 'number') {
      values.billDate = Number(values.billDate);
    }
    if (values.refundAmount !== undefined && typeof values.refundAmount !== 'number') {
      values.refundAmount = Number(values.refundAmount);
    }
    if (values.totalCost !== undefined && typeof values.totalCost !== 'number') {
      values.totalCost = Number(values.totalCost);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cgst !== undefined && typeof values.cgst !== 'number') {
      values.cgst = Number(values.cgst);
    }
    if (values.sgst !== undefined && typeof values.sgst !== 'number') {
      values.sgst = Number(values.sgst);
    }
    if (values.printCount !== undefined && typeof values.printCount !== 'number') {
      values.printCount = Number(values.printCount);
    }
    if (values.voidedDate !== undefined && typeof values.voidedDate !== 'number') {
      values.voidedDate = Number(values.voidedDate);
    }
    if (values.roundOffVal !== undefined && typeof values.roundOffVal !== 'number') {
      values.roundOffVal = Number(values.roundOffVal);
    }

    const entity = {
      ...pharmacyRefundBillEntity,
      ...values,
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      glucoUser: glucoUsers.find(it => it.id.toString() === values.glucoUser?.toString()),
      pharmacist: tenantEmployees.find(it => it.id.toString() === values.pharmacist?.toString()),
      saleBill: pharmacyBills.find(it => it.id.toString() === values.saleBill?.toString()),
      returnBill: pharmacyReturnBills.find(it => it.id.toString() === values.returnBill?.toString()),
      admission: admissions.find(it => it.id.toString() === values.admission?.toString()),
      consumer: pharmacies.find(it => it.id.toString() === values.consumer?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          patientType: 'OP',
          billFor: 'BUSINESS',
          ...pharmacyRefundBillEntity,
          pharmacy: pharmacyRefundBillEntity?.pharmacy?.id,
          glucoUser: pharmacyRefundBillEntity?.glucoUser?.id,
          pharmacist: pharmacyRefundBillEntity?.pharmacist?.id,
          saleBill: pharmacyRefundBillEntity?.saleBill?.id,
          returnBill: pharmacyRefundBillEntity?.returnBill?.id,
          admission: pharmacyRefundBillEntity?.admission?.id,
          consumer: pharmacyRefundBillEntity?.consumer?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyRefundBill.home.createOrEditLabel" data-cy="PharmacyRefundBillCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyRefundBill.home.createOrEditLabel">
              Create or edit a PharmacyRefundBill
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-refund-bill-id"
                  label={translate('tinyMedicRestApp.pharmacyRefundBill.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.billNumber')}
                id="pharmacy-refund-bill-billNumber"
                name="billNumber"
                data-cy="billNumber"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.billDate')}
                id="pharmacy-refund-bill-billDate"
                name="billDate"
                data-cy="billDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.refundAmount')}
                id="pharmacy-refund-bill-refundAmount"
                name="refundAmount"
                data-cy="refundAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.totalCost')}
                id="pharmacy-refund-bill-totalCost"
                name="totalCost"
                data-cy="totalCost"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.discount')}
                id="pharmacy-refund-bill-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.active')}
                id="pharmacy-refund-bill-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.cursor')}
                id="pharmacy-refund-bill-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.timestampentry')}
                id="pharmacy-refund-bill-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.microSec')}
                id="pharmacy-refund-bill-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.lastupdated')}
                id="pharmacy-refund-bill-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.cgst')}
                id="pharmacy-refund-bill-cgst"
                name="cgst"
                data-cy="cgst"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.sgst')}
                id="pharmacy-refund-bill-sgst"
                name="sgst"
                data-cy="sgst"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.patientType')}
                id="pharmacy-refund-bill-patientType"
                name="patientType"
                data-cy="patientType"
                type="select"
              >
                {patientTypeValues.map(patientType => (
                  <option value={patientType} key={patientType}>
                    {translate(`tinyMedicRestApp.PatientType.${patientType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.printed')}
                id="pharmacy-refund-bill-printed"
                name="printed"
                data-cy="printed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.printCount')}
                id="pharmacy-refund-bill-printCount"
                name="printCount"
                data-cy="printCount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.voided')}
                id="pharmacy-refund-bill-voided"
                name="voided"
                data-cy="voided"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.voidedReason')}
                id="pharmacy-refund-bill-voidedReason"
                name="voidedReason"
                data-cy="voidedReason"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.voidedDate')}
                id="pharmacy-refund-bill-voidedDate"
                name="voidedDate"
                data-cy="voidedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.roundOffVal')}
                id="pharmacy-refund-bill-roundOffVal"
                name="roundOffVal"
                data-cy="roundOffVal"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.billFor')}
                id="pharmacy-refund-bill-billFor"
                name="billFor"
                data-cy="billFor"
                type="select"
              >
                {billForValues.map(billFor => (
                  <option value={billFor} key={billFor}>
                    {translate(`tinyMedicRestApp.BillFor.${billFor}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.billForId')}
                id="pharmacy-refund-bill-billForId"
                name="billForId"
                data-cy="billForId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyRefundBill.status')}
                id="pharmacy-refund-bill-status"
                name="status"
                data-cy="status"
                type="text"
              />
              <ValidatedField
                id="pharmacy-refund-bill-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyRefundBill.pharmacy')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-refund-bill-glucoUser"
                name="glucoUser"
                data-cy="glucoUser"
                label={translate('tinyMedicRestApp.pharmacyRefundBill.glucoUser')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-refund-bill-pharmacist"
                name="pharmacist"
                data-cy="pharmacist"
                label={translate('tinyMedicRestApp.pharmacyRefundBill.pharmacist')}
                type="select"
              >
                <option value="" key="0" />
                {tenantEmployees
                  ? tenantEmployees.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-refund-bill-saleBill"
                name="saleBill"
                data-cy="saleBill"
                label={translate('tinyMedicRestApp.pharmacyRefundBill.saleBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-refund-bill-returnBill"
                name="returnBill"
                data-cy="returnBill"
                label={translate('tinyMedicRestApp.pharmacyRefundBill.returnBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyReturnBills
                  ? pharmacyReturnBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-refund-bill-admission"
                name="admission"
                data-cy="admission"
                label={translate('tinyMedicRestApp.pharmacyRefundBill.admission')}
                type="select"
              >
                <option value="" key="0" />
                {admissions
                  ? admissions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-refund-bill-consumer"
                name="consumer"
                data-cy="consumer"
                label={translate('tinyMedicRestApp.pharmacyRefundBill.consumer')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-refund-bill" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyRefundBillUpdate;
